import { useMutation } from '@tanstack/react-query'
import { authApi, type ChangePasswordRequest } from '@/api/auth'

export function useChangePassword() {
  return useMutation({
    mutationFn: async (data: ChangePasswordRequest) => {
      const res = await authApi.changePassword(data)
      return res.data.data
    },
  })
}
